module.exports = __webpack_public_path__ + "static/media/palvelut.f874319f.jpg";